// Entry point for the build script in package.json

// Hotwire
import "@hotwired/turbo-rails"
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

// カスタム Turbo Stream アクション: redirect
// 使用例: turbo_stream.action(:redirect, path)
Turbo.StreamActions.redirect = function() {
  Turbo.visit(this.target)
}

// カスタム Turbo Stream アクション: modal_close
// 使用例: turbo_stream.action(:modal_close)
Turbo.StreamActions.modal_close = function() {
  const dialog = document.querySelector("[data-modal-target='dialog']")
  if (dialog) {
    dialog.open = false
    const frame = dialog.querySelector("turbo-frame")
    if (frame) {
      frame.innerHTML = ""
      frame.src = ""
    }
    dialog.label = ""
  }
}

// カスタム Turbo Stream アクション: refresh_frame（指定IDのturbo-frameを再読み込み）
// 使用例: turbo_stream.action(:refresh_frame, "projects-list")
Turbo.StreamActions.refresh_frame = function() {
  const frame = document.getElementById(this.target)
  if (!frame) return

  if (frame.src) {
    frame.reload()
  } else {
    frame.src = window.location.href
  }
}

// Web Awesome theme and utilities
import "@awesome.me/webawesome/dist/styles/themes/default.css"
import "@awesome.me/webawesome/dist/styles/utilities.css"

// App utilities
import "../assets/stylesheets/utilities.css"
import "../assets/stylesheets/toast.css"

// Web Awesome components (add as needed)
import "@awesome.me/webawesome/dist/components/button/button.js"
import "@awesome.me/webawesome/dist/components/drawer/drawer.js"
import "@awesome.me/webawesome/dist/components/input/input.js"
import "@awesome.me/webawesome/dist/components/card/card.js"
import "@awesome.me/webawesome/dist/components/select/select.js"
import "@awesome.me/webawesome/dist/components/option/option.js"
import "@awesome.me/webawesome/dist/components/icon/icon.js"
import "@awesome.me/webawesome/dist/components/badge/badge.js"
import "@awesome.me/webawesome/dist/components/callout/callout.js"
import "@awesome.me/webawesome/dist/components/dialog/dialog.js"
import "@awesome.me/webawesome/dist/components/dropdown/dropdown.js"
import "@awesome.me/webawesome/dist/components/dropdown-item/dropdown-item.js"
import "@awesome.me/webawesome/dist/components/spinner/spinner.js"
import "@awesome.me/webawesome/dist/components/tag/tag.js"
import "@awesome.me/webawesome/dist/components/checkbox/checkbox.js"
import "@awesome.me/webawesome/dist/components/divider/divider.js"
import "@awesome.me/webawesome/dist/components/radio/radio.js"
import "@awesome.me/webawesome/dist/components/radio-group/radio-group.js"
import "@awesome.me/webawesome/dist/components/textarea/textarea.js"
import "@awesome.me/webawesome/dist/components/tooltip/tooltip.js"
